import { render } from "./FullscreenOverlay.vue?vue&type=template&id=94c56598&scoped=true"
import script from "./FullscreenOverlay.vue?vue&type=script&lang=js"
export * from "./FullscreenOverlay.vue?vue&type=script&lang=js"

import "./FullscreenOverlay.vue?vue&type=style&index=0&id=94c56598&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c56598"]])

export default __exports__